//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import * as OM from "../Model";
import { baseUrl } from "../config";
import { CommonServices } from "./CommonServices";
import router from '@/router'
import VueRouter from 'vue-router';

class _NotificationClient {







































  sendPushNotification(model : OM.SendNotificationVm, showSpinner = true) : Promise<void> {
    return CommonServices.defaultPost<void>(baseUrl + 'api/Notification/SendPushNotification', model, { }, showSpinner)

  }




























  getLast10Notification(showSpinner = true) : Promise<OM.Notification[]> {
    return CommonServices.defaultGet<OM.Notification[]>(baseUrl + 'api/Notification/GetLast10Notification', {  }, showSpinner)

  }







































  setRead(notificationIdentifier : string, showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/Notification/SetRead', { notificationIdentifier }, showSpinner)

  }




























  setAllRead(showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/Notification/SetAllRead', {  }, showSpinner)

  }
}
export let NotificationClient = new _NotificationClient();

class _AgencyClient {







































  getAllAgency(onlyActive : boolean, showSpinner = true) : Promise<OM.AgencyVM[]> {
    return CommonServices.defaultGet<OM.AgencyVM[]>(baseUrl + 'api/Agency/GetAllAgency', { onlyActive }, showSpinner)

  }







































  getAgencyByIdentifier(agencyIdentifier : string, showSpinner = true) : Promise<OM.AgencyVM> {
    return CommonServices.defaultGet<OM.AgencyVM>(baseUrl + 'api/Agency/GetAgencyByIdentifier', { agencyIdentifier }, showSpinner)

  }







































  updateAgency(agencyVm : OM.AgencyVM, showSpinner = true) : Promise<OM.AgencyVM> {
    return CommonServices.defaultPost<OM.AgencyVM>(baseUrl + 'api/Agency/UpdateAgency', agencyVm, { }, showSpinner)

  }




























  getAllAgent(showSpinner = true) : Promise<OM.AgentVM[]> {
    return CommonServices.defaultGet<OM.AgentVM[]>(baseUrl + 'api/Agency/GetAllAgent', {  }, showSpinner)

  }







































  updateAgent(agentVm : OM.AgentVM, showSpinner = true) : Promise<OM.AgentVM> {
    return CommonServices.defaultPost<OM.AgentVM>(baseUrl + 'api/Agency/UpdateAgent', agentVm, { }, showSpinner)

  }







































  approveAgent(agent : OM.AgentVM, showSpinner = true) : Promise<OM.AgentVM> {
    return CommonServices.defaultPost<OM.AgentVM>(baseUrl + 'api/Agency/ApproveAgent', agent, { }, showSpinner)

  }
}
export let AgencyClient = new _AgencyClient();

class _AppleAuthClient {




























  getAuthLink(showSpinner = true) : Promise<string> {
    return CommonServices.defaultGet<string>(baseUrl + 'api/AppleAuth/GetAuthLink', {  }, showSpinner)

  }







































  redirectCode(code : string, showSpinner = true) : Promise<OM.LoggedUserVM> {
    return CommonServices.defaultGet<OM.LoggedUserVM>(baseUrl + 'api/AppleAuth/RedirectCode', { code }, showSpinner)

  }







































  redirectAccessToken(accessToken : string, showSpinner = true) : Promise<OM.LoggedUserVM> {
    return CommonServices.defaultGet<OM.LoggedUserVM>(baseUrl + 'api/AppleAuth/RedirectAccessToken', { accessToken }, showSpinner)

  }
}
export let AppleAuthClient = new _AppleAuthClient();

class _AvailabilityClient {


















































  getPricePeriod(availabilityIdentifier : string, vehicleIdentifier : string, showSpinner = true) : Promise<OM.PricePeriodAvailabilityVm> {
    return CommonServices.defaultGet<OM.PricePeriodAvailabilityVm>(baseUrl + 'api/Availability/GetPricePeriod', { availabilityIdentifier, vehicleIdentifier }, showSpinner)

  }







































  getAvailability(vehicleIdentifier : string, showSpinner = true) : Promise<OM.AvailabilityListVM[]> {
    return CommonServices.defaultGet<OM.AvailabilityListVM[]>(baseUrl + 'api/Availability/GetAvailability', { vehicleIdentifier }, showSpinner)

  }







































  getBackofficeAvailability(vehicleIdentifier : string, showSpinner = true) : Promise<OM.AvailabilityListVM[]> {
    return CommonServices.defaultGet<OM.AvailabilityListVM[]>(baseUrl + 'api/Availability/GetBackofficeAvailability', { vehicleIdentifier }, showSpinner)

  }







































  getParkingAvailabilityForVehicleOwner(ownerId : string, showSpinner = true) : Promise<OM.ReservationResumeBox[]> {
    return CommonServices.defaultGet<OM.ReservationResumeBox[]>(baseUrl + 'api/Availability/GetParkingAvailabilityForVehicleOwner', { ownerId }, showSpinner)

  }







































  getDisabledDatesBeforeBooking(vehicleIdentifier : string, showSpinner = true) : Promise<OM.DatePeriod[]> {
    return CommonServices.defaultGet<OM.DatePeriod[]>(baseUrl + 'api/Availability/GetDisabledDatesBeforeBooking', { vehicleIdentifier }, showSpinner)

  }







































  searchLocation(searchBody : OM.SearchLocationFilterVM, showSpinner = true) : Promise<OM.LocationResultVM[]> {
    return CommonServices.defaultPost<OM.LocationResultVM[]>(baseUrl + 'api/Availability/SearchLocation', searchBody, { }, showSpinner)

  }







































  searchVehiclesInLocation(searchBody : OM.SearchCarFilterVM, showSpinner = true) : Promise<OM.VehiclesInLocationSearchResultVM> {
    return CommonServices.defaultPost<OM.VehiclesInLocationSearchResultVM>(baseUrl + 'api/Availability/SearchVehiclesInLocation', searchBody, { }, showSpinner)

  }







































  getAvailabilityById(availabilityId : string, showSpinner = true) : Promise<OM.UpdateAvailabilityVM> {
    return CommonServices.defaultGet<OM.UpdateAvailabilityVM>(baseUrl + 'api/Availability/GetAvailabilityById', { availabilityId }, showSpinner)

  }







































  editAvailability(item : OM.UpdateAvailabilityVM, showSpinner = true) : Promise<OM.UpdateAvailabilityVM> {
    return CommonServices.defaultPost<OM.UpdateAvailabilityVM>(baseUrl + 'api/Availability/EditAvailability', item, { }, showSpinner)

  }







































  createAvailability(item : OM.CreateAvailabilityVm, showSpinner = true) : Promise<OM.CreateAvailabilityVm> {
    return CommonServices.defaultPost<OM.CreateAvailabilityVm>(baseUrl + 'api/Availability/CreateAvailability', item, { }, showSpinner)

  }







































  updatePrice(item : OM.UpdateSimplePriceVM, showSpinner = true) : Promise<OM.UpdateSimplePriceVM> {
    return CommonServices.defaultPost<OM.UpdateSimplePriceVM>(baseUrl + 'api/Availability/UpdatePrice', item, { }, showSpinner)

  }







































  updatePriceVariations(item : OM.ChangePriceVariationsVM, showSpinner = true) : Promise<OM.UpdateAvailabilityVM> {
    return CommonServices.defaultPost<OM.UpdateAvailabilityVM>(baseUrl + 'api/Availability/UpdatePriceVariations', item, { }, showSpinner)

  }







































  updateLocation(item : OM.UpdateLocationsVM, showSpinner = true) : Promise<OM.UpdateLocationsVM> {
    return CommonServices.defaultPost<OM.UpdateLocationsVM>(baseUrl + 'api/Availability/UpdateLocation', item, { }, showSpinner)

  }







































  updatePeriod(item : OM.UpdateDatePeriodVM, showSpinner = true) : Promise<OM.UpdateDatePeriodVM> {
    return CommonServices.defaultPost<OM.UpdateDatePeriodVM>(baseUrl + 'api/Availability/UpdatePeriod', item, { }, showSpinner)

  }




























  getPriceFilter(showSpinner = true) : Promise<OM.PriceFilterVM> {
    return CommonServices.defaultGet<OM.PriceFilterVM>(baseUrl + 'api/Availability/GetPriceFilter', {  }, showSpinner)

  }







































  searchLocationsCarList(searchBody : OM.SearchLocationFilterVM, showSpinner = true) : Promise<OM.VehiclesFilteredOnLocationVM[]> {
    return CommonServices.defaultPost<OM.VehiclesFilteredOnLocationVM[]>(baseUrl + 'api/Availability/SearchLocationsCarList', searchBody, { }, showSpinner)

  }







































  deleteAvailability(availabilityIdentifier : string, showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/Availability/DeleteAvailability', { availabilityIdentifier }, showSpinner)

  }







































  getSolarDaysCount(period : OM.DatePeriod, showSpinner = true) : Promise<number> {
    return CommonServices.defaultPost<number>(baseUrl + 'api/Availability/GetSolarDaysCount', period, { }, showSpinner)

  }







































  disableAvailability(availabilityIdentifier : string, showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/Availability/DisableAvailability', { availabilityIdentifier }, showSpinner)

  }







































  enableAvailability(availabilityIdentifier : string, showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/Availability/EnableAvailability', { availabilityIdentifier }, showSpinner)

  }
}
export let AvailabilityClient = new _AvailabilityClient();

class _BalanceClient {




























  dashboard(showSpinner = true) : Promise<OM.BalanceDashboardVm> {
    return CommonServices.defaultGet<OM.BalanceDashboardVm>(baseUrl + 'api/Balance/Dashboard', {  }, showSpinner)

  }




























  userAccountStatements(showSpinner = true) : Promise<OM.UserStatementsVm> {
    return CommonServices.defaultGet<OM.UserStatementsVm>(baseUrl + 'api/Balance/UserAccountStatements', {  }, showSpinner)

  }







































  userAccountStatementsBackend(userIdentifier : string, showSpinner = true) : Promise<OM.UserStatementsVm> {
    return CommonServices.defaultGet<OM.UserStatementsVm>(baseUrl + 'api/Balance/UserAccountStatementsBackend', { userIdentifier }, showSpinner)

  }







































  forceBalanceMovement(model : OM.ForceBalanceMovementVm, showSpinner = true) : Promise<void> {
    return CommonServices.defaultPost<void>(baseUrl + 'api/Balance/ForceBalanceMovement', model, { }, showSpinner)

  }
}
export let BalanceClient = new _BalanceClient();

class _ConfigurationClient {




























  serviceList(showSpinner = true) : Promise<OM.ConfigurationServiceItemVM[]> {
    return CommonServices.defaultGet<OM.ConfigurationServiceItemVM[]>(baseUrl + 'api/Configuration/ServiceList', {  }, showSpinner)

  }







































  saveServiceItem(model : OM.SaveConfigServiceItemVM, showSpinner = true) : Promise<OM.ConfigurationServiceItemVM> {
    return CommonServices.defaultPost<OM.ConfigurationServiceItemVM>(baseUrl + 'api/Configuration/SaveServiceItem', model, { }, showSpinner)

  }

















































  uploadServiceIcon(serviceIdentifier : string, file : File, progressFn: (prog) => void = null, showSpinner = true) : Promise<string> {
    return CommonServices.uploadFileToUrl<string>(baseUrl + 'api/Configuration/UploadServiceIcon?serviceIdentifier=' + serviceIdentifier, file, { }, progressFn, showSpinner)

  }




























  accessoryList(showSpinner = true) : Promise<OM.ConfigurationAccessoryItemVM[]> {
    return CommonServices.defaultGet<OM.ConfigurationAccessoryItemVM[]>(baseUrl + 'api/Configuration/AccessoryList', {  }, showSpinner)

  }







































  saveAccessoryItem(model : OM.SaveConfigAccessoryItemVM, showSpinner = true) : Promise<OM.ConfigurationAccessoryItemVM> {
    return CommonServices.defaultPost<OM.ConfigurationAccessoryItemVM>(baseUrl + 'api/Configuration/SaveAccessoryItem', model, { }, showSpinner)

  }




























  categoryList(showSpinner = true) : Promise<string[]> {
    return CommonServices.defaultGet<string[]>(baseUrl + 'api/Configuration/CategoryList', {  }, showSpinner)

  }

















































  uploadAccessoryIcon(accessoryItemIdentifier : string, file : File, progressFn: (prog) => void = null, showSpinner = true) : Promise<string> {
    return CommonServices.uploadFileToUrl<string>(baseUrl + 'api/Configuration/UploadAccessoryIcon?accessoryItemIdentifier=' + accessoryItemIdentifier, file, { }, progressFn, showSpinner)

  }




























  vehicleFeatureList(showSpinner = true) : Promise<OM.TextImageIdItemVM[]> {
    return CommonServices.defaultGet<OM.TextImageIdItemVM[]>(baseUrl + 'api/Configuration/VehicleFeatureList', {  }, showSpinner)

  }







































  saveVehicleFeature(feature : OM.TextImageIdItemVM, showSpinner = true) : Promise<OM.TextImageIdItemVM> {
    return CommonServices.defaultPost<OM.TextImageIdItemVM>(baseUrl + 'api/Configuration/SaveVehicleFeature', feature, { }, showSpinner)

  }




























  vehicleUseConditionList(showSpinner = true) : Promise<OM.TextImageIdItemVM[]> {
    return CommonServices.defaultGet<OM.TextImageIdItemVM[]>(baseUrl + 'api/Configuration/VehicleUseConditionList', {  }, showSpinner)

  }







































  saveVehicleUseCondition(useCondition : OM.TextImageIdItemVM, showSpinner = true) : Promise<OM.TextImageIdItemVM> {
    return CommonServices.defaultPost<OM.TextImageIdItemVM>(baseUrl + 'api/Configuration/SaveVehicleUseCondition', useCondition, { }, showSpinner)

  }




























  getConfigurationBasePrice(showSpinner = true) : Promise<OM.ConfigurationBasePriceVM[]> {
    return CommonServices.defaultGet<OM.ConfigurationBasePriceVM[]>(baseUrl + 'api/Configuration/GetConfigurationBasePrice', {  }, showSpinner)

  }







































  saveConfigurationBasePrice(item : OM.ConfigurationBasePriceVM, showSpinner = true) : Promise<OM.ConfigurationBasePriceVM> {
    return CommonServices.defaultPost<OM.ConfigurationBasePriceVM>(baseUrl + 'api/Configuration/SaveConfigurationBasePrice', item, { }, showSpinner)

  }




























  getConfigurationPriceTag(showSpinner = true) : Promise<OM.SaveConfigurationPriceTagVM[]> {
    return CommonServices.defaultGet<OM.SaveConfigurationPriceTagVM[]>(baseUrl + 'api/Configuration/GetConfigurationPriceTag', {  }, showSpinner)

  }







































  saveConfigurationPriceTag(priceTag : OM.SaveConfigurationPriceTagVM, showSpinner = true) : Promise<OM.SaveConfigurationPriceTagVM> {
    return CommonServices.defaultPost<OM.SaveConfigurationPriceTagVM>(baseUrl + 'api/Configuration/SaveConfigurationPriceTag', priceTag, { }, showSpinner)

  }
















































































































  getAllConfigurationPriceCondition(pagedRequestVM: OM.PagedRequestVM, router: VueRouter, showSpinner = true) : Promise<OM.PagedResponseOfSaveConfigurationPriceConditionVM> {
    var paramsObject: any = getCustomPagedRequestParamsObject(pagedRequestVM);
    pushHistoryState(pagedRequestVM, router);
                return CommonServices.defaultGet<OM.PagedResponseOfSaveConfigurationPriceConditionVM>(baseUrl + 'api/Configuration/GetAllConfigurationPriceCondition', paramsObject, showSpinner)

  }




























  getApplicableConfigurationPriceCondition(showSpinner = true) : Promise<OM.SaveConfigurationPriceConditionVM[]> {
    return CommonServices.defaultGet<OM.SaveConfigurationPriceConditionVM[]>(baseUrl + 'api/Configuration/GetApplicableConfigurationPriceCondition', {  }, showSpinner)

  }







































  getSelectableConfigurationPriceCondition(selectedIdentifier : string, showSpinner = true) : Promise<OM.SaveConfigurationPriceConditionVM[]> {
    return CommonServices.defaultGet<OM.SaveConfigurationPriceConditionVM[]>(baseUrl + 'api/Configuration/GetSelectableConfigurationPriceCondition', { selectedIdentifier }, showSpinner)

  }







































  saveConfigurationPriceCondition(priceCondition : OM.SaveConfigurationPriceConditionVM, showSpinner = true) : Promise<OM.SaveConfigurationPriceConditionVM> {
    return CommonServices.defaultPost<OM.SaveConfigurationPriceConditionVM>(baseUrl + 'api/Configuration/SaveConfigurationPriceCondition', priceCondition, { }, showSpinner)

  }






























































































































  getConfigurationPriceRule(pagedRequestVM: OM.PriceRulePagedRequestVM, router: VueRouter, showSpinner = true) : Promise<OM.PagedResponseOfConfigurationPriceRuleVM> {
    var paramsObject: any = getCustomPagedRequestParamsObject(pagedRequestVM);
    pushHistoryState(pagedRequestVM, router);
                return CommonServices.defaultGet<OM.PagedResponseOfConfigurationPriceRuleVM>(baseUrl + 'api/Configuration/GetConfigurationPriceRule', paramsObject, showSpinner)

  }







































  saveConfigurationPriceRule(priceRule : OM.ConfigurationPriceRule, showSpinner = true) : Promise<OM.ConfigurationPriceRuleVM> {
    return CommonServices.defaultPost<OM.ConfigurationPriceRuleVM>(baseUrl + 'api/Configuration/SaveConfigurationPriceRule', priceRule, { }, showSpinner)

  }







































  changeStatus(priceRuleIdentifier : string, showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/Configuration/ChangeStatus', { priceRuleIdentifier }, showSpinner)

  }







































  deletePriceRule(priceRuleIdentifier : string, showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/Configuration/DeletePriceRule', { priceRuleIdentifier }, showSpinner)

  }







































  deletePriceCondition(priceConditionIdentifier : string, showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/Configuration/DeletePriceCondition', { priceConditionIdentifier }, showSpinner)

  }




























  pointOfInterestList(showSpinner = true) : Promise<OM.ConfigurationPointOfInterestVM[]> {
    return CommonServices.defaultGet<OM.ConfigurationPointOfInterestVM[]>(baseUrl + 'api/Configuration/PointOfInterestList', {  }, showSpinner)

  }







































  savePointOfInterest(model : OM.SaveConfigPointOfInterestVM, showSpinner = true) : Promise<OM.ConfigurationPointOfInterestVM> {
    return CommonServices.defaultPost<OM.ConfigurationPointOfInterestVM>(baseUrl + 'api/Configuration/SavePointOfInterest', model, { }, showSpinner)

  }

















































  uploadPointOfInteresIcon(pointOfInterestIdentifier : string, file : File, progressFn: (prog) => void = null, showSpinner = true) : Promise<string> {
    return CommonServices.uploadFileToUrl<string>(baseUrl + 'api/Configuration/UploadPointOfInteresIcon?pointOfInterestIdentifier=' + pointOfInterestIdentifier, file, { }, progressFn, showSpinner)

  }




























  getVehicleGroupCode(showSpinner = true) : Promise<string[]> {
    return CommonServices.defaultGet<string[]>(baseUrl + 'api/Configuration/GetVehicleGroupCode', {  }, showSpinner)

  }







































  getSippCodesForProvider(provider : string, showSpinner = true) : Promise<string[]> {
    return CommonServices.defaultGet<string[]>(baseUrl + 'api/Configuration/GetSippCodesForProvider', { provider }, showSpinner)

  }







































  getSippCodesForOwner(ownerIdentifier : string, showSpinner = true) : Promise<string[]> {
    return CommonServices.defaultGet<string[]>(baseUrl + 'api/Configuration/GetSippCodesForOwner', { ownerIdentifier }, showSpinner)

  }







































  getSippCodesGroupMapping(provider : string, showSpinner = true) : Promise<OM.SippCodeGroupMapping[]> {
    return CommonServices.defaultGet<OM.SippCodeGroupMapping[]>(baseUrl + 'api/Configuration/GetSippCodesGroupMapping', { provider }, showSpinner)

  }







































  getSippCodesGroupMappingByIdentifier(apiProfessionaIdentifier : string, showSpinner = true) : Promise<OM.SippCodeGroupMapping[]> {
    return CommonServices.defaultGet<OM.SippCodeGroupMapping[]>(baseUrl + 'api/Configuration/GetSippCodesGroupMappingByIdentifier', { apiProfessionaIdentifier }, showSpinner)

  }
}
export let ConfigurationClient = new _ConfigurationClient();

class _CouponClient {




























  isMobilityCardActive(showSpinner = true) : Promise<boolean> {
    return CommonServices.defaultGet<boolean>(baseUrl + 'api/Coupon/IsMobilityCardActive', {  }, showSpinner)

  }




























  getAllBuyableMobilityCard(showSpinner = true) : Promise<OM.BuyableCouponVM[]> {
    return CommonServices.defaultGet<OM.BuyableCouponVM[]>(baseUrl + 'api/Coupon/GetAllBuyableMobilityCard', {  }, showSpinner)

  }







































  getOrCreateMobilityCard(couponVM : OM.BuyableCouponVM, showSpinner = true) : Promise<string> {
    return CommonServices.defaultPost<string>(baseUrl + 'api/Coupon/GetOrCreateMobilityCard', couponVM, { }, showSpinner)

  }




























  getUserCoupons(showSpinner = true) : Promise<OM.CouponResumeVM[]> {
    return CommonServices.defaultGet<OM.CouponResumeVM[]>(baseUrl + 'api/Coupon/GetUserCoupons', {  }, showSpinner)

  }







































  getByIdentifier(couponIdentifier : string, showSpinner = true) : Promise<OM.CouponResumeVM> {
    return CommonServices.defaultGet<OM.CouponResumeVM>(baseUrl + 'api/Coupon/GetByIdentifier', { couponIdentifier }, showSpinner)

  }







































  confirmMobilityCard(couponIdentifier : string, showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/Coupon/ConfirmMobilityCard', { couponIdentifier }, showSpinner)

  }




























  getAllCoupons(showSpinner = true) : Promise<OM.CouponResumeVM[]> {
    return CommonServices.defaultGet<OM.CouponResumeVM[]>(baseUrl + 'api/Coupon/GetAllCoupons', {  }, showSpinner)

  }
}
export let CouponClient = new _CouponClient();

class _CustomerClient {







































  register(user : OM.CustomerRegistrationVm, showSpinner = true) : Promise<OM.LoggedUserVM> {
    return CommonServices.defaultPost<OM.LoggedUserVM>(baseUrl + 'api/Customer/Register', user, { }, showSpinner)

  }







































  getCustomerById(identifier : string, showSpinner = true) : Promise<OM.CustomerVM> {
    return CommonServices.defaultGet<OM.CustomerVM>(baseUrl + 'api/Customer/GetCustomerById', { identifier }, showSpinner)

  }







































  saveCustomer(customer : OM.CustomerVM, showSpinner = true) : Promise<OM.CustomerVM> {
    return CommonServices.defaultPost<OM.CustomerVM>(baseUrl + 'api/Customer/SaveCustomer', customer, { }, showSpinner)

  }







































  checkIfProfileComplete(userIdentifier : string, showSpinner = true) : Promise<boolean> {
    return CommonServices.defaultGet<boolean>(baseUrl + 'api/Customer/CheckIfProfileComplete', { userIdentifier }, showSpinner)

  }







































  updateCustomerBankData(customerBankData : OM.CustomerBankDataVm, showSpinner = true) : Promise<void> {
    return CommonServices.defaultPost<void>(baseUrl + 'api/Customer/UpdateCustomerBankData', customerBankData, { }, showSpinner)

  }




























  getCustomersBalance(showSpinner = true) : Promise<OM.CustomerBalanceVM[]> {
    return CommonServices.defaultGet<OM.CustomerBalanceVM[]>(baseUrl + 'api/Customer/GetCustomersBalance', {  }, showSpinner)

  }







































  getFiscalData(userIdentifier : string, showSpinner = true) : Promise<OM.FiscalData[]> {
    return CommonServices.defaultGet<OM.FiscalData[]>(baseUrl + 'api/Customer/GetFiscalData', { userIdentifier }, showSpinner)

  }







































  getFiscalDataByIdentifier(fiscalDataIdentifier : string, showSpinner = true) : Promise<OM.FiscalData> {
    return CommonServices.defaultGet<OM.FiscalData>(baseUrl + 'api/Customer/GetFiscalDataByIdentifier', { fiscalDataIdentifier }, showSpinner)

  }







































  getCustomerFiscalDataList(customerIdentifier : string, showSpinner = true) : Promise<OM.FiscalDataVM[]> {
    return CommonServices.defaultGet<OM.FiscalDataVM[]>(baseUrl + 'api/Customer/GetCustomerFiscalDataList', { customerIdentifier }, showSpinner)

  }







































  saveFiscalData(fiscalData : OM.FiscalData, showSpinner = true) : Promise<string> {
    return CommonServices.defaultPost<string>(baseUrl + 'api/Customer/SaveFiscalData', fiscalData, { }, showSpinner)

  }







































  getCustomerAddress(userIdentifier : string, showSpinner = true) : Promise<OM.Address> {
    return CommonServices.defaultGet<OM.Address>(baseUrl + 'api/Customer/GetCustomerAddress', { userIdentifier }, showSpinner)

  }




























  getNews(showSpinner = true) : Promise<OM.CustomerNews> {
    return CommonServices.defaultGet<OM.CustomerNews>(baseUrl + 'api/Customer/GetNews', {  }, showSpinner)

  }







































  registerLead(user : OM.CustomerRegistrationVm, showSpinner = true) : Promise<void> {
    return CommonServices.defaultPost<void>(baseUrl + 'api/Customer/RegisterLead', user, { }, showSpinner)

  }




























  getLeads(showSpinner = true) : Promise<OM.LeadVM[]> {
    return CommonServices.defaultPost<OM.LeadVM[]>(baseUrl + 'api/Customer/GetLeads', null, { }, showSpinner)

  }







































  completeCustomerProfile(user : OM.CustomerCompleteProfileVm, showSpinner = true) : Promise<OM.User> {
    return CommonServices.defaultPost<OM.User>(baseUrl + 'api/Customer/CompleteCustomerProfile', user, { }, showSpinner)

  }







































  login(model : OM.LanguageCredential, showSpinner = true) : Promise<OM.LoggedUserVM> {
    return CommonServices.defaultPost<OM.LoggedUserVM>(baseUrl + 'api/Customer/Login', model, { }, showSpinner)

  }




























  checkIfProfileIsValid(showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/Customer/CheckIfProfileIsValid', {  }, showSpinner)

  }




























  getCompleteProfileVM(showSpinner = true) : Promise<OM.CompleteProfileVM> {
    return CommonServices.defaultGet<OM.CompleteProfileVM>(baseUrl + 'api/Customer/GetCompleteProfileVM', {  }, showSpinner)

  }







































  completeProfile(vm : OM.CompleteProfileVM, showSpinner = true) : Promise<string> {
    return CommonServices.defaultPost<string>(baseUrl + 'api/Customer/CompleteProfile', vm, { }, showSpinner)

  }







































  sendVerificationPhone(phone : string, showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/Customer/SendVerificationPhone', { phone }, showSpinner)

  }







































  checkVerificationPhone(code : string, showSpinner = true) : Promise<boolean> {
    return CommonServices.defaultGet<boolean>(baseUrl + 'api/Customer/CheckVerificationPhone', { code }, showSpinner)

  }







































  setFCMID(fcmIdValue : string, showSpinner = true) : Promise<string> {
    return CommonServices.defaultGet<string>(baseUrl + 'api/Customer/SetFCMID', { fcmIdValue }, showSpinner)

  }






































  impersonate(userToImpersonateIdentifier : string, showSpinner = true) : Promise<OM.ImpersonatedUserVM> {
    return CommonServices.defaultPost<OM.ImpersonatedUserVM>(baseUrl + 'api/Customer/Impersonate?userToImpersonateIdentifier=' + userToImpersonateIdentifier, { }, { }, showSpinner)

  }




























  getInternalUsers(showSpinner = true) : Promise<OM.WithLocationUserVM[]> {
    return CommonServices.defaultGet<OM.WithLocationUserVM[]>(baseUrl + 'api/Customer/GetInternalUsers', {  }, showSpinner)

  }




























  getCustomers(showSpinner = true) : Promise<OM.CustomerVM[]> {
    return CommonServices.defaultGet<OM.CustomerVM[]>(baseUrl + 'api/Customer/GetCustomers', {  }, showSpinner)

  }







































  getCustomersListForSelect(inputData : string, showSpinner = true) : Promise<OM.CustomerVM[]> {
    return CommonServices.defaultGet<OM.CustomerVM[]>(baseUrl + 'api/Customer/GetCustomersListForSelect', { inputData }, showSpinner)

  }




























  getSubmittedCustomers(showSpinner = true) : Promise<OM.CustomerVM[]> {
    return CommonServices.defaultGet<OM.CustomerVM[]>(baseUrl + 'api/Customer/GetSubmittedCustomers', {  }, showSpinner)

  }




























  getRole(showSpinner = true) : Promise<string> {
    return CommonServices.defaultGet<string>(baseUrl + 'api/Customer/GetRole', {  }, showSpinner)

  }







































  getById(identifier : string, showSpinner = true) : Promise<OM.UserVM> {
    return CommonServices.defaultGet<OM.UserVM>(baseUrl + 'api/Customer/GetById', { identifier }, showSpinner)

  }




























  getLocationManagers(showSpinner = true) : Promise<OM.ThumbnailBaseUserVM[]> {
    return CommonServices.defaultGet<OM.ThumbnailBaseUserVM[]>(baseUrl + 'api/Customer/GetLocationManagers', {  }, showSpinner)

  }




























  getProfessionalOwners(showSpinner = true) : Promise<OM.ThumbnailBaseUserVM[]> {
    return CommonServices.defaultGet<OM.ThumbnailBaseUserVM[]>(baseUrl + 'api/Customer/GetProfessionalOwners', {  }, showSpinner)

  }




























  getApiProfessionalOwners(showSpinner = true) : Promise<OM.ThumbnailBaseUserVM[]> {
    return CommonServices.defaultGet<OM.ThumbnailBaseUserVM[]>(baseUrl + 'api/Customer/GetApiProfessionalOwners', {  }, showSpinner)

  }




























  getVehicleOwners(showSpinner = true) : Promise<OM.ThumbnailBaseUserVM[]> {
    return CommonServices.defaultGet<OM.ThumbnailBaseUserVM[]>(baseUrl + 'api/Customer/GetVehicleOwners', {  }, showSpinner)

  }







































  saveInternalUser(user : OM.WithLocationUserVM, showSpinner = true) : Promise<OM.WithLocationUserVM> {
    return CommonServices.defaultPost<OM.WithLocationUserVM>(baseUrl + 'api/Customer/SaveInternalUser', user, { }, showSpinner)

  }




























  getOwnerList(showSpinner = true) : Promise<OM.CustomerVM[]> {
    return CommonServices.defaultGet<OM.CustomerVM[]>(baseUrl + 'api/Customer/GetOwnerList', {  }, showSpinner)

  }




























  getPrefissiList(showSpinner = true) : Promise<OM.ExtendedCountry[]> {
    return CommonServices.defaultGet<OM.ExtendedCountry[]>(baseUrl + 'api/Customer/GetPrefissiList', {  }, showSpinner)

  }







































  changePassword(changePassword : OM.ChangePasswordVM, showSpinner = true) : Promise<void> {
    return CommonServices.defaultPost<void>(baseUrl + 'api/Customer/ChangePassword', changePassword, { }, showSpinner)

  }







































  approve(model : OM.EntityApproveVm, showSpinner = true) : Promise<void> {
    return CommonServices.defaultPost<void>(baseUrl + 'api/Customer/Approve', model, { }, showSpinner)

  }







































  refuse(model : OM.EntityApproveVm, showSpinner = true) : Promise<void> {
    return CommonServices.defaultPost<void>(baseUrl + 'api/Customer/Refuse', model, { }, showSpinner)

  }







































  setPreference(setPreference : OM.SetPreferenceVM, showSpinner = true) : Promise<void> {
    return CommonServices.defaultPost<void>(baseUrl + 'api/Customer/SetPreference', setPreference, { }, showSpinner)

  }







































  resetPassword(model : OM.LanguageCredential, showSpinner = true) : Promise<void> {
    return CommonServices.defaultPost<void>(baseUrl + 'api/Customer/ResetPassword', model, { }, showSpinner)

  }




























  getUserSummary(showSpinner = true) : Promise<OM.UserSummaryVM> {
    return CommonServices.defaultGet<OM.UserSummaryVM>(baseUrl + 'api/Customer/GetUserSummary', {  }, showSpinner)

  }







































  changeStatus(userIdentifier : string, showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/Customer/ChangeStatus', { userIdentifier }, showSpinner)

  }







































  updatePreferredCulture(culture : string, showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/Customer/UpdatePreferredCulture', { culture }, showSpinner)

  }
}
export let CustomerClient = new _CustomerClient();

class _DebugClient {




























  importModelFromApi(showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/Debug/ImportModelFromApi', {  }, showSpinner)

  }







































  notifyReservationSuccess(reservationIdentifier : string, showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/Debug/NotifyReservationSuccess', { reservationIdentifier }, showSpinner)

  }




























  sendMobilityCardMarketingMessage(showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/Debug/SendMobilityCardMarketingMessage', {  }, showSpinner)

  }




























  exportInsurance(showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/Debug/ExportInsurance', {  }, showSpinner)

  }




























  exportCustomer(showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/Debug/ExportCustomer', {  }, showSpinner)

  }




























  exportPriceAvailabilities(showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/Debug/ExportPriceAvailabilities', {  }, showSpinner)

  }




























  updateInsuranceGoogleSheet(showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/Debug/UpdateInsuranceGoogleSheet', {  }, showSpinner)

  }




























  notifyReservationAlarms(showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/Debug/NotifyReservationAlarms', {  }, showSpinner)

  }




























  notifyNotCompletedProfile(showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/Debug/NotifyNotCompletedProfile', {  }, showSpinner)

  }




























  invoiceWeeklyReport(showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/Debug/InvoiceWeeklyReport', {  }, showSpinner)

  }


















































  statsReport(start : string, end : string, showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/Debug/StatsReport', { start, end }, showSpinner)

  }


















































  statsBossReport(start : string, end : string, showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/Debug/StatsBossReport', { start, end }, showSpinner)

  }


















































  statsRenthubBossReport(start : string, end : string, showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/Debug/StatsRenthubBossReport', { start, end }, showSpinner)

  }


















































  statsRenthubBossReportUsingStartDate(start : string, end : string, showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/Debug/StatsRenthubBossReportUsingStartDate', { start, end }, showSpinner)

  }


















































  cdaStatsReport(start : string, end : string, showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/Debug/CdaStatsReport', { start, end }, showSpinner)

  }




























  weeklyCdaStatsReport(showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/Debug/WeeklyCdaStatsReport', {  }, showSpinner)

  }


















































  reservationCounterStatsReport(start : string, end : string, showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/Debug/ReservationCounterStatsReport', { start, end }, showSpinner)

  }


















































  customInvoiceReport(start : string, end : string, showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/Debug/CustomInvoiceReport', { start, end }, showSpinner)

  }




























  statsAvailabilityReport(showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/Debug/StatsAvailabilityReport', {  }, showSpinner)

  }




























  invoiceMonthlyReport(showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/Debug/InvoiceMonthlyReport', {  }, showSpinner)

  }


















































  leolandiaReport(start : string, end : string, showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/Debug/LeolandiaReport', { start, end }, showSpinner)

  }


















































  yamahaReport(start : string, end : string, showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/Debug/YamahaReport', { start, end }, showSpinner)

  }


















































  spidiReport(start : string, end : string, showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/Debug/SpidiReport', { start, end }, showSpinner)

  }




























  manageApiReservation(showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/Debug/ManageApiReservation', {  }, showSpinner)

  }




























  resetPasswordAndMailNotity(showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/Debug/ResetPasswordAndMailNotity', {  }, showSpinner)

  }




























  generatePwdHash(showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/Debug/GeneratePwdHash', {  }, showSpinner)

  }




























  addBonusCredit(showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/Debug/AddBonusCredit', {  }, showSpinner)

  }




























  error(showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/Debug/Error', {  }, showSpinner)

  }




























  longTime(showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/Debug/LongTime', {  }, showSpinner)

  }




























  getErrorVm(showSpinner = true) : Promise<OM.ErrorVm> {
    return CommonServices.defaultGet<OM.ErrorVm>(baseUrl + 'api/Debug/GetErrorVm', {  }, showSpinner)

  }




























  testException(showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/Debug/TestException', {  }, showSpinner)

  }




























  checkLogin(showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/Debug/CheckLogin', {  }, showSpinner)

  }







































  parseLegacyDate(legacyDate : string, showSpinner = true) : Promise<Date> {
    return CommonServices.defaultGet<Date>(baseUrl + 'api/Debug/ParseLegacyDate', { legacyDate }, showSpinner)

  }




























  testLog(showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/Debug/TestLog', {  }, showSpinner)

  }




























  rs24RenthubAvailabilityMonitoring(showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/Debug/Rs24RenthubAvailabilityMonitoring', {  }, showSpinner)

  }


















































  generateCouponCodeStats(start : string, end : string, showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/Debug/GenerateCouponCodeStats', { start, end }, showSpinner)

  }




























  testEnvironment(showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/Debug/TestEnvironment', {  }, showSpinner)

  }




























  importCurrencyRate(showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/Debug/ImportCurrencyRate', {  }, showSpinner)

  }




























  getQuartzScheduledTriggers(showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/Debug/GetQuartzScheduledTriggers', {  }, showSpinner)

  }




























  getQuartzScheduledJobs(showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/Debug/GetQuartzScheduledJobs', {  }, showSpinner)

  }
}
export let DebugClient = new _DebugClient();

class _ExternalClient {




























  getAll(showSpinner = true) : Promise<OM.ApiVehicleVM[]> {
    return CommonServices.defaultGet<OM.ApiVehicleVM[]>(baseUrl + 'api/External/GetAll', {  }, showSpinner)

  }







































  getById(vehicleIdentifier : string, showSpinner = true) : Promise<OM.ApiVehicleVM> {
    return CommonServices.defaultGet<OM.ApiVehicleVM>(baseUrl + 'api/External/GetById', { vehicleIdentifier }, showSpinner)

  }







































  save(vehicle : OM.ApiVehicleVM, showSpinner = true) : Promise<OM.ApiVehicleVM> {
    return CommonServices.defaultPost<OM.ApiVehicleVM>(baseUrl + 'api/External/Save', vehicle, { }, showSpinner)

  }







































  deleteApiVehicleModel(apiVehicle : OM.ApiVehicleDeleteVM, showSpinner = true) : Promise<void> {
    return CommonServices.defaultPost<void>(baseUrl + 'api/External/DeleteApiVehicleModel', apiVehicle, { }, showSpinner)

  }
}
export let ExternalClient = new _ExternalClient();

class _FacebookauthClient {




























  getauthlink(showSpinner = true) : Promise<string> {
    return CommonServices.defaultGet<string>(baseUrl + 'facebookauth/getauthlink', {  }, showSpinner)

  }







































  redirectcode(code : string, showSpinner = true) : Promise<OM.LoggedUserVM> {
    return CommonServices.defaultGet<OM.LoggedUserVM>(baseUrl + 'facebookauth/redirectcode', { code }, showSpinner)

  }







































  redirectaccesstoken(access_token : string, showSpinner = true) : Promise<OM.LoggedUserVM> {
    return CommonServices.defaultGet<OM.LoggedUserVM>(baseUrl + 'facebookauth/redirectaccesstoken', { access_token }, showSpinner)

  }
}
export let FacebookauthClient = new _FacebookauthClient();

class _GoogleAuthClient {




























  getAuthLink(showSpinner = true) : Promise<string> {
    return CommonServices.defaultGet<string>(baseUrl + 'api/GoogleAuth/GetAuthLink', {  }, showSpinner)

  }







































  redirectCode(code : string, showSpinner = true) : Promise<OM.LoggedUserVM> {
    return CommonServices.defaultGet<OM.LoggedUserVM>(baseUrl + 'api/GoogleAuth/RedirectCode', { code }, showSpinner)

  }







































  redirectAccessToken(accessToken : string, showSpinner = true) : Promise<OM.LoggedUserVM> {
    return CommonServices.defaultGet<OM.LoggedUserVM>(baseUrl + 'api/GoogleAuth/RedirectAccessToken', { accessToken }, showSpinner)

  }
}
export let GoogleAuthClient = new _GoogleAuthClient();

class _InsuranceClient {




























  insuranceConfigurationList(showSpinner = true) : Promise<OM.ConfigurationInsuranceItem[]> {
    return CommonServices.defaultGet<OM.ConfigurationInsuranceItem[]>(baseUrl + 'api/Insurance/InsuranceConfigurationList', {  }, showSpinner)

  }







































  getInsuranceForReservation(reservationIdentifier : string, showSpinner = true) : Promise<OM.UpdateInsuranceVm[]> {
    return CommonServices.defaultGet<OM.UpdateInsuranceVm[]>(baseUrl + 'api/Insurance/GetInsuranceForReservation', { reservationIdentifier }, showSpinner)

  }







































  getInsuranceForVehicle(vehicleIdentifier : string, showSpinner = true) : Promise<OM.ConfigurationInsuranceItem[]> {
    return CommonServices.defaultGet<OM.ConfigurationInsuranceItem[]>(baseUrl + 'api/Insurance/GetInsuranceForVehicle', { vehicleIdentifier }, showSpinner)

  }







































  saveInsuranceConfiguration(item : OM.ConfigurationInsuranceItemSaveVM, showSpinner = true) : Promise<OM.ConfigurationInsuranceItem> {
    return CommonServices.defaultPost<OM.ConfigurationInsuranceItem>(baseUrl + 'api/Insurance/SaveInsuranceConfiguration', item, { }, showSpinner)

  }







































  deleteInsurance(insuranceIdentifier : string, showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/Insurance/DeleteInsurance', { insuranceIdentifier }, showSpinner)

  }
}
export let InsuranceClient = new _InsuranceClient();

class _LocalizationClient {




























  getBackofficeDictionary(showSpinner = true) : Promise<OM.LocalizedEntity[]> {
    return CommonServices.defaultGet<OM.LocalizedEntity[]>(baseUrl + 'api/Localization/GetBackofficeDictionary', {  }, showSpinner)

  }




























  getSiteDictionary(showSpinner = true) : Promise<OM.LocalizedEntity[]> {
    return CommonServices.defaultGet<OM.LocalizedEntity[]>(baseUrl + 'api/Localization/GetSiteDictionary', {  }, showSpinner)

  }







































  saveSiteLocalizedEntity(item : OM.LocalizedEntity, showSpinner = true) : Promise<void> {
    return CommonServices.defaultPost<void>(baseUrl + 'api/Localization/SaveSiteLocalizedEntity', item, { }, showSpinner)

  }







































  getClausole(reservationIdentifier : string, showSpinner = true) : Promise<{ [key: string]: string; }> {
    return CommonServices.defaultGet<{ [key: string]: string; }>(baseUrl + 'api/Localization/GetClausole', { reservationIdentifier }, showSpinner)

  }




























  getCountries(showSpinner = true) : Promise<OM.RS24LocalizedEntity[]> {
    return CommonServices.defaultGet<OM.RS24LocalizedEntity[]>(baseUrl + 'api/Localization/GetCountries', {  }, showSpinner)

  }




























  getAppDictionary(showSpinner = true) : Promise<OM.LocalizedEntity[]> {
    return CommonServices.defaultGet<OM.LocalizedEntity[]>(baseUrl + 'api/Localization/GetAppDictionary', {  }, showSpinner)

  }




























  getAll(showSpinner = true) : Promise<OM.LocalizedEntity[]> {
    return CommonServices.defaultGet<OM.LocalizedEntity[]>(baseUrl + 'api/Localization/GetAll', {  }, showSpinner)

  }




























  getEnabledLanguages(showSpinner = true) : Promise<string[]> {
    return CommonServices.defaultGet<string[]>(baseUrl + 'api/Localization/GetEnabledLanguages', {  }, showSpinner)

  }




























  getSupportedLanguages(showSpinner = true) : Promise<string[]> {
    return CommonServices.defaultGet<string[]>(baseUrl + 'api/Localization/GetSupportedLanguages', {  }, showSpinner)

  }







































  saveLocalizedValue(item : OM.KeyValuePairOfStringAndString, showSpinner = true) : Promise<void> {
    return CommonServices.defaultPost<void>(baseUrl + 'api/Localization/SaveLocalizedValue', item, { }, showSpinner)

  }







































  editLocalizedValue(value : OM.LocalizedEntity, showSpinner = true) : Promise<void> {
    return CommonServices.defaultPost<void>(baseUrl + 'api/Localization/EditLocalizedValue', value, { }, showSpinner)

  }
}
export let LocalizationClient = new _LocalizationClient();

class _LocationAreaClient {




























  getAllAreas(showSpinner = true) : Promise<OM.AreaVM[]> {
    return CommonServices.defaultGet<OM.AreaVM[]>(baseUrl + 'api/LocationArea/GetAllAreas', {  }, showSpinner)

  }







































  save(area : OM.AreaVM, showSpinner = true) : Promise<OM.AreaVM> {
    return CommonServices.defaultPost<OM.AreaVM>(baseUrl + 'api/LocationArea/Save', area, { }, showSpinner)

  }
}
export let LocationAreaClient = new _LocationAreaClient();

class _LocationClient {







































  getById(locationIdentifier : string, showSpinner = true) : Promise<OM.LocationVM> {
    return CommonServices.defaultGet<OM.LocationVM>(baseUrl + 'api/Location/GetById', { locationIdentifier }, showSpinner)

  }







































  getApiLocationById(locationIdentifier : string, showSpinner = true) : Promise<OM.ApiLocationVM> {
    return CommonServices.defaultGet<OM.ApiLocationVM>(baseUrl + 'api/Location/GetApiLocationById', { locationIdentifier }, showSpinner)

  }







































  getLocationDetail(locationIdentifier : string, showSpinner = true) : Promise<OM.LocationProfileVM> {
    return CommonServices.defaultGet<OM.LocationProfileVM>(baseUrl + 'api/Location/GetLocationDetail', { locationIdentifier }, showSpinner)

  }




























  getList(showSpinner = true) : Promise<OM.LocationListVM[]> {
    return CommonServices.defaultGet<OM.LocationListVM[]>(baseUrl + 'api/Location/GetList', {  }, showSpinner)

  }




























  getLocationList(showSpinner = true) : Promise<OM.LocationListVM[]> {
    return CommonServices.defaultGet<OM.LocationListVM[]>(baseUrl + 'api/Location/GetLocationList', {  }, showSpinner)

  }




























  getApiLocationList(showSpinner = true) : Promise<OM.ApiLocationListVM[]> {
    return CommonServices.defaultGet<OM.ApiLocationListVM[]>(baseUrl + 'api/Location/GetApiLocationList', {  }, showSpinner)

  }







































  getLocationAccessory(locationIdentifier : string, showSpinner = true) : Promise<OM.SellableAccessoryItemVM[]> {
    return CommonServices.defaultGet<OM.SellableAccessoryItemVM[]>(baseUrl + 'api/Location/GetLocationAccessory', { locationIdentifier }, showSpinner)

  }




























  getLocationsProvince(showSpinner = true) : Promise<OM.ProvinceVM[]> {
    return CommonServices.defaultGet<OM.ProvinceVM[]>(baseUrl + 'api/Location/GetLocationsProvince', {  }, showSpinner)

  }







































  save(location : OM.LocationVM, showSpinner = true) : Promise<string> {
    return CommonServices.defaultPost<string>(baseUrl + 'api/Location/Save', location, { }, showSpinner)

  }







































  saveApiLocation(location : OM.ApiLocationVM, showSpinner = true) : Promise<string> {
    return CommonServices.defaultPost<string>(baseUrl + 'api/Location/SaveApiLocation', location, { }, showSpinner)

  }






























































  manageLocationImages(apiLocationIdentifier : string, imagesToRemove : string[], files : File[], progressFn: (prog) => void = null, showSpinner = true) : Promise<void> {
    return CommonServices.uploadFilesToUrl<void>(baseUrl + 'api/Location/ManageLocationImages?apiLocationIdentifier=' + apiLocationIdentifier + '&imagesToRemove=' + imagesToRemove, files, { }, progressFn, showSpinner)

  }




























  getAvailabilityLocations(showSpinner = true) : Promise<OM.LocationAvailabilityListVM[]> {
    return CommonServices.defaultGet<OM.LocationAvailabilityListVM[]>(baseUrl + 'api/Location/GetAvailabilityLocations', {  }, showSpinner)

  }







































  getP2PAvailabilityLocations(vehicleIdentifier : string, showSpinner = true) : Promise<OM.LocationAvailabilityListVM[]> {
    return CommonServices.defaultGet<OM.LocationAvailabilityListVM[]>(baseUrl + 'api/Location/GetP2PAvailabilityLocations', { vehicleIdentifier }, showSpinner)

  }







































  changeStatus(locationIdentifier : string, showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/Location/ChangeStatus', { locationIdentifier }, showSpinner)

  }







































  getGroupByPoiAndCity(culture : string, showSpinner = true) : Promise<OM.PoiCitiesCountVM[]> {
    return CommonServices.defaultGet<OM.PoiCitiesCountVM[]>(baseUrl + 'api/Location/GetGroupByPoiAndCity', { culture }, showSpinner)

  }
































































  getSiteLocationByPoiCity(siteCity : string, poi : string, culture : string, showSpinner = true) : Promise<OM.KeyValuePairOfStringAndString[]> {
    return CommonServices.defaultGet<OM.KeyValuePairOfStringAndString[]>(baseUrl + 'api/Location/GetSiteLocationByPoiCity', { siteCity, poi, culture }, showSpinner)

  }


















































  getBySiteSlug(siteSlug : string, culture : string, showSpinner = true) : Promise<OM.SiteLocationDetailVM> {
    return CommonServices.defaultGet<OM.SiteLocationDetailVM>(baseUrl + 'api/Location/GetBySiteSlug', { siteSlug, culture }, showSpinner)

  }




























  getLocationSlugCities(showSpinner = true) : Promise<string[]> {
    return CommonServices.defaultGet<string[]>(baseUrl + 'api/Location/GetLocationSlugCities', {  }, showSpinner)

  }
}
export let LocationClient = new _LocationClient();

class _LocationManagerClient {




























  getReservations(showSpinner = true) : Promise<OM.ReservationSummaryDataVm[]> {
    return CommonServices.defaultGet<OM.ReservationSummaryDataVm[]>(baseUrl + 'api/LocationManager/GetReservations', {  }, showSpinner)

  }







































  getReservationDetail(reservationId : string, showSpinner = true) : Promise<OM.ReservationDetailVm> {
    return CommonServices.defaultGet<OM.ReservationDetailVm>(baseUrl + 'api/LocationManager/GetReservationDetail', { reservationId }, showSpinner)

  }







































  ownerCheckin(reservationIdentifier : string, showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/LocationManager/OwnerCheckin', { reservationIdentifier }, showSpinner)

  }







































  driverCheckout(model : OM.CheckInOutVm, showSpinner = true) : Promise<void> {
    return CommonServices.defaultPost<void>(baseUrl + 'api/LocationManager/DriverCheckout', model, { }, showSpinner)

  }







































  driverCheckin(model : OM.CheckInOutVm, showSpinner = true) : Promise<void> {
    return CommonServices.defaultPost<void>(baseUrl + 'api/LocationManager/DriverCheckin', model, { }, showSpinner)

  }







































  ownerCheckout(reservationIdentifier : string, showSpinner = true) : Promise<OM.LocationVM> {
    return CommonServices.defaultGet<OM.LocationVM>(baseUrl + 'api/LocationManager/OwnerCheckout', { reservationIdentifier }, showSpinner)

  }




























  getAllCustomers(showSpinner = true) : Promise<OM.CustomerForListVm[]> {
    return CommonServices.defaultGet<OM.CustomerForListVm[]>(baseUrl + 'api/LocationManager/GetAllCustomers', {  }, showSpinner)

  }







































  getVehicleByPlate(plate : string, showSpinner = true) : Promise<string> {
    return CommonServices.defaultGet<string>(baseUrl + 'api/LocationManager/GetVehicleByPlate', { plate }, showSpinner)

  }







































  getDriverDocumentLink(userIdentifier : string, showSpinner = true) : Promise<OM.CompleteDriverProfileVM> {
    return CommonServices.defaultGet<OM.CompleteDriverProfileVM>(baseUrl + 'api/LocationManager/GetDriverDocumentLink', { userIdentifier }, showSpinner)

  }







































  completeDriverProfile(model : OM.CompleteDriverProfileVM, showSpinner = true) : Promise<void> {
    return CommonServices.defaultPost<void>(baseUrl + 'api/LocationManager/CompleteDriverProfile', model, { }, showSpinner)

  }
}
export let LocationManagerClient = new _LocationManagerClient();

class _OperatorJobClient {


















































  rs24SyncAllReservationsForMonth(month : number, year : number, showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/OperatorJob/Rs24SyncAllReservationsForMonth', { month, year }, showSpinner)

  }
































































  rs24SyncAllReservationsFromDay(month : number, year : number, day : number, showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/OperatorJob/Rs24SyncAllReservationsFromDay', { month, year, day }, showSpinner)

  }
































































  computeSplitForMonth(month : number, year : number, forceSplit : boolean, showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/OperatorJob/ComputeSplitForMonth', { month, year, forceSplit }, showSpinner)

  }


















































  generateBrokerPrepaidReportForMonth(month : number, year : number, showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/OperatorJob/GenerateBrokerPrepaidReportForMonth', { month, year }, showSpinner)

  }




























  rHOperatorTestLogging(showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/OperatorJob/RHOperatorTestLogging', {  }, showSpinner)

  }
































































  rs24SyncVehiclesFromDay(month : number, year : number, day : number, showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/OperatorJob/Rs24SyncVehiclesFromDay', { month, year, day }, showSpinner)

  }




























  rs24SyncPricelist(showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/OperatorJob/Rs24SyncPricelist', {  }, showSpinner)

  }






















































































  updatePuvDarReport(skipDataRefresh : boolean, year : number, month : number, day : number, onlyDar : boolean, showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/OperatorJob/UpdatePuvDarReport', { skipDataRefresh, year, month, day, onlyDar }, showSpinner)

  }














































































  updateDarReport(skipDataRefresh : boolean, year : number, month : number, day : number, showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/OperatorJob/UpdateDarReport', { skipDataRefresh, year, month, day }, showSpinner)

  }
































































  alarmManagement(month : number, year : number, day : number, showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/OperatorJob/AlarmManagement', { month, year, day }, showSpinner)

  }


















































  computeKpiForCustomPeriod(start : string, end : string, showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/OperatorJob/ComputeKpiForCustomPeriod', { start, end }, showSpinner)

  }














































































  computeLeaseCarBrokerKpi(day : number, month : number, year : number, wholeMonth : boolean, showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/OperatorJob/ComputeLeaseCarBrokerKpi', { day, month, year, wholeMonth }, showSpinner)

  }
































































  generatePuvReport(year : number, month : number, day : number, showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/OperatorJob/GeneratePuvReport', { year, month, day }, showSpinner)

  }
































































  generateLeaseCarBrokerPuvReport(year : number, month : number, day : number, showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/OperatorJob/GenerateLeaseCarBrokerPuvReport', { year, month, day }, showSpinner)

  }


















































  getVehiclesInLocationForDate(targetDate : string, locationId : number, showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/OperatorJob/GetVehiclesInLocationForDate', { targetDate, locationId }, showSpinner)

  }




























  updateVehiclesInRhReservations(showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/OperatorJob/UpdateVehiclesInRhReservations', {  }, showSpinner)

  }




























  updatePickupLocations(showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/OperatorJob/UpdatePickupLocations', {  }, showSpinner)

  }




























  updateAndLogPlateNumber(showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/OperatorJob/UpdateAndLogPlateNumber', {  }, showSpinner)

  }




























  fillLeasysFinesFile(showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/OperatorJob/FillLeasysFinesFile', {  }, showSpinner)

  }
































































  fillVehicleInTechnicalStop(year : number, month : number, day : number, showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/OperatorJob/FillVehicleInTechnicalStop', { year, month, day }, showSpinner)

  }







































  manageDiscoverFraudFile(filename : string, showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/OperatorJob/ManageDiscoverFraudFile', { filename }, showSpinner)

  }







































  syncBookings(bookingIds : number[], showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/OperatorJob/SyncBookings', { bookingIds }, showSpinner)

  }
































































  rs24SyncAllDisputesFromDay(month : number, year : number, day : number, showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/OperatorJob/Rs24SyncAllDisputesFromDay', { month, year, day }, showSpinner)

  }







































  generateDisputeReport(start : string, showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/OperatorJob/GenerateDisputeReport', { start }, showSpinner)

  }
}
export let OperatorJobClient = new _OperatorJobClient();

class _ParkingoClient {




























  getParkingoAreas(showSpinner = true) : Promise<OM.ParkingoAreaVM[]> {
    return CommonServices.defaultGet<OM.ParkingoAreaVM[]>(baseUrl + 'api/Parkingo/GetParkingoAreas', {  }, showSpinner)

  }







































  getParkingoAvailabilityAndPrice(parkingoAvailabilityRequestVM : OM.ParkingoAvailabilityRequestVM, showSpinner = true) : Promise<OM.ParkingoAvailabilityResponseVM> {
    return CommonServices.defaultPost<OM.ParkingoAvailabilityResponseVM>(baseUrl + 'api/Parkingo/GetParkingoAvailabilityAndPrice', parkingoAvailabilityRequestVM, { }, showSpinner)

  }







































  parkingoReservation(parkingoReservationRequestVM : OM.ParkingoReservationRequestVM, showSpinner = true) : Promise<OM.ParkingoReservationResponseVM> {
    return CommonServices.defaultPost<OM.ParkingoReservationResponseVM>(baseUrl + 'api/Parkingo/ParkingoReservation', parkingoReservationRequestVM, { }, showSpinner)

  }







































  parkingoDeleteReservation(parkingoReservationRequestVM : OM.ParkingoReservationRequestVM, showSpinner = true) : Promise<OM.ParkingoReservationResponseVM> {
    return CommonServices.defaultPost<OM.ParkingoReservationResponseVM>(baseUrl + 'api/Parkingo/ParkingoDeleteReservation', parkingoReservationRequestVM, { }, showSpinner)

  }







































  notifyOwnerCheckin(parkingoCheckinVM : OM.ParkingoCheckInVM, showSpinner = true) : Promise<void> {
    return CommonServices.defaultPost<void>(baseUrl + 'api/Parkingo/NotifyOwnerCheckin', parkingoCheckinVM, { }, showSpinner)

  }















































































































  getCarsAvailabilitiesByArea(secret : string, areaIdentifier : string, start : string, end : string, culture : string, phase : string, pNow : string, showSpinner = true) : Promise<OM.ParkingoSearchResultVM> {
    return CommonServices.defaultGet<OM.ParkingoSearchResultVM>(baseUrl + 'api/Parkingo/GetCarsAvailabilitiesByArea', { secret, areaIdentifier, start, end, culture, phase, pNow }, showSpinner)

  }







































  getAreas(secret : string, showSpinner = true) : Promise<OM.AreaDataVM[]> {
    return CommonServices.defaultGet<OM.AreaDataVM[]>(baseUrl + 'api/Parkingo/GetAreas', { secret }, showSpinner)

  }
































































  getShuttleDemandForPeriod(secret : string, start : string, end : string, showSpinner = true) : Promise<OM.ShuttleDemandVM> {
    return CommonServices.defaultGet<OM.ShuttleDemandVM>(baseUrl + 'api/Parkingo/GetShuttleDemandForPeriod', { secret, start, end }, showSpinner)

  }







































  getActiveVehicles(secret : string, showSpinner = true) : Promise<string[]> {
    return CommonServices.defaultGet<string[]>(baseUrl + 'api/Parkingo/GetActiveVehicles', { secret }, showSpinner)

  }
}
export let ParkingoClient = new _ParkingoClient();

class _ReservationClient {




























  requestsList(showSpinner = true) : Promise<OM.ReservationResumeBox[]> {
    return CommonServices.defaultGet<OM.ReservationResumeBox[]>(baseUrl + 'api/Reservation/RequestsList', {  }, showSpinner)

  }




























  myReservationsList(showSpinner = true) : Promise<OM.ReservationResumeBox[]> {
    return CommonServices.defaultGet<OM.ReservationResumeBox[]>(baseUrl + 'api/Reservation/MyReservationsList', {  }, showSpinner)

  }







































  getReservationSummary(reservationIdentifier : string, showSpinner = true) : Promise<OM.ReservationSummaryVM> {
    return CommonServices.defaultGet<OM.ReservationSummaryVM>(baseUrl + 'api/Reservation/GetReservationSummary', { reservationIdentifier }, showSpinner)

  }




























  getReservationIdentifier(showSpinner = true) : Promise<string> {
    return CommonServices.defaultGet<string>(baseUrl + 'api/Reservation/GetReservationIdentifier', {  }, showSpinner)

  }




























  backendGetReservationIdentifier(showSpinner = true) : Promise<string> {
    return CommonServices.defaultGet<string>(baseUrl + 'api/Reservation/BackendGetReservationIdentifier', {  }, showSpinner)

  }







































  updateLocation(locationVm : OM.UpdateReservationLocationVm, showSpinner = true) : Promise<OM.ReservationVm> {
    return CommonServices.defaultPost<OM.ReservationVm>(baseUrl + 'api/Reservation/UpdateLocation', locationVm, { }, showSpinner)

  }







































  updateFiscalData(fiscalDataVm : OM.UpdateReservationFiscalDataVm, showSpinner = true) : Promise<OM.ReservationVm> {
    return CommonServices.defaultPost<OM.ReservationVm>(baseUrl + 'api/Reservation/UpdateFiscalData', fiscalDataVm, { }, showSpinner)

  }







































  updatePeriod(periodVm : OM.UpdateReservationPeriodVm, showSpinner = true) : Promise<OM.ReservationVm> {
    return CommonServices.defaultPost<OM.ReservationVm>(baseUrl + 'api/Reservation/UpdatePeriod', periodVm, { }, showSpinner)

  }







































  updateDriver(driverVm : OM.UpdateDriverVm, showSpinner = true) : Promise<OM.ReservationVm> {
    return CommonServices.defaultPost<OM.ReservationVm>(baseUrl + 'api/Reservation/UpdateDriver', driverVm, { }, showSpinner)

  }







































  changePeriod(model : OM.UpdateReservationPeriodVm, showSpinner = true) : Promise<void> {
    return CommonServices.defaultPost<void>(baseUrl + 'api/Reservation/ChangePeriod', model, { }, showSpinner)

  }







































  updateApiVehicle(avaVm : OM.UpdateApiVehicleVm, showSpinner = true) : Promise<OM.ReservationVm> {
    return CommonServices.defaultPost<OM.ReservationVm>(baseUrl + 'api/Reservation/UpdateApiVehicle', avaVm, { }, showSpinner)

  }







































  updateAvailability(avaVm : OM.UpdateReservationAvailabilityVm, showSpinner = true) : Promise<OM.ReservationVm> {
    return CommonServices.defaultPost<OM.ReservationVm>(baseUrl + 'api/Reservation/UpdateAvailability', avaVm, { }, showSpinner)

  }







































  updateAccessories(accVm : OM.UpdateAccessoriesVm, showSpinner = true) : Promise<OM.ReservationVm> {
    return CommonServices.defaultPost<OM.ReservationVm>(baseUrl + 'api/Reservation/UpdateAccessories', accVm, { }, showSpinner)

  }







































  updateInsurance(insuranceVm : OM.UpdateInsuranceBaseVm, showSpinner = true) : Promise<OM.ReservationVm> {
    return CommonServices.defaultPost<OM.ReservationVm>(baseUrl + 'api/Reservation/UpdateInsurance', insuranceVm, { }, showSpinner)

  }







































  askForReservationCancellation(reservationIdentifier : string, showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/Reservation/AskForReservationCancellation', { reservationIdentifier }, showSpinner)

  }







































  replaceCancelledReservation(cancelledReservationIdentifier : string, showSpinner = true) : Promise<OM.BackofficeReservationDetailVM> {
    return CommonServices.defaultGet<OM.BackofficeReservationDetailVM>(baseUrl + 'api/Reservation/ReplaceCancelledReservation', { cancelledReservationIdentifier }, showSpinner)

  }







































  confirmReservation(reservationIdentifier : string, showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/Reservation/ConfirmReservation', { reservationIdentifier }, showSpinner)

  }







































  rejectReservation(reservationId : string, showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/Reservation/RejectReservation', { reservationId }, showSpinner)

  }







































  voidReservation(model : OM.VoidReservationVm, showSpinner = true) : Promise<void> {
    return CommonServices.defaultPost<void>(baseUrl + 'api/Reservation/VoidReservation', model, { }, showSpinner)

  }







































  backofficeRejectReservation(reservationId : string, showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/Reservation/BackofficeRejectReservation', { reservationId }, showSpinner)

  }






























































































































  getAll(pagedRequestVM: OM.ReservationPagedRequestVM, router: VueRouter, showSpinner = true) : Promise<OM.PagedResponseOfReservationListVM> {
    var paramsObject: any = getCustomPagedRequestParamsObject(pagedRequestVM);
    pushHistoryState(pagedRequestVM, router);
                return CommonServices.defaultGet<OM.PagedResponseOfReservationListVM>(baseUrl + 'api/Reservation/GetAll', paramsObject, showSpinner)

  }







































  getById(reservationIdentifier : string, showSpinner = true) : Promise<OM.BackofficeReservationDetailVM> {
    return CommonServices.defaultGet<OM.BackofficeReservationDetailVM>(baseUrl + 'api/Reservation/GetById', { reservationIdentifier }, showSpinner)

  }







































  checkIfVehicleIsReserved(reservationIdentifier : string, showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/Reservation/CheckIfVehicleIsReserved', { reservationIdentifier }, showSpinner)

  }


















































  getReservationDetailForCustomer(reservationId : string, isRequest : boolean, showSpinner = true) : Promise<OM.DetailReservationForCustomer> {
    return CommonServices.defaultGet<OM.DetailReservationForCustomer>(baseUrl + 'api/Reservation/GetReservationDetailForCustomer', { reservationId, isRequest }, showSpinner)

  }







































  createCustomReservation(customRes : OM.CreateCustomReservationVm, showSpinner = true) : Promise<OM.VehicleReservation> {
    return CommonServices.defaultPost<OM.VehicleReservation>(baseUrl + 'api/Reservation/CreateCustomReservation', customRes, { }, showSpinner)

  }







































  addNote(note : OM.NoteVM, showSpinner = true) : Promise<OM.Note> {
    return CommonServices.defaultPost<OM.Note>(baseUrl + 'api/Reservation/AddNote', note, { }, showSpinner)

  }







































  addFee(addFee : OM.AdditionalFeeVM, showSpinner = true) : Promise<OM.AdditionalFee> {
    return CommonServices.defaultPost<OM.AdditionalFee>(baseUrl + 'api/Reservation/AddFee', addFee, { }, showSpinner)

  }







































  payAdditionalFee(addFee : OM.PayAdditionalFee, showSpinner = true) : Promise<void> {
    return CommonServices.defaultPost<void>(baseUrl + 'api/Reservation/PayAdditionalFee', addFee, { }, showSpinner)

  }







































  addPriceVariation(priceVariation : OM.PriceVariationVM, showSpinner = true) : Promise<void> {
    return CommonServices.defaultPost<void>(baseUrl + 'api/Reservation/AddPriceVariation', priceVariation, { }, showSpinner)

  }


















































  removePriceVariation(reservationIdentifier : string, position : number, showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/Reservation/RemovePriceVariation', { reservationIdentifier, position }, showSpinner)

  }







































  downloadCheckinContract(reservationIdentifier : string, showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/Reservation/DownloadCheckinContract', { reservationIdentifier }, showSpinner)

  }







































  downloadCheckoutContract(reservationIdentifier : string, showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/Reservation/DownloadCheckoutContract', { reservationIdentifier }, showSpinner)

  }







































  updateCheckoutContract(reservationIdentifier : string, showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/Reservation/UpdateCheckoutContract', { reservationIdentifier }, showSpinner)

  }







































  updateCheckinContract(reservationIdentifier : string, showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/Reservation/UpdateCheckinContract', { reservationIdentifier }, showSpinner)

  }


















































  removeFee(reservationIdentifier : string, position : number, showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/Reservation/RemoveFee', { reservationIdentifier, position }, showSpinner)

  }







































  changeVehicle(changeVehicle : OM.ChangeVehicleVM, showSpinner = true) : Promise<void> {
    return CommonServices.defaultPost<void>(baseUrl + 'api/Reservation/ChangeVehicle', changeVehicle, { }, showSpinner)

  }







































  loadDocuments(reservation : OM.BackofficeReservationDetailVM, showSpinner = true) : Promise<OM.BackofficeReservationDetailVM> {
    return CommonServices.defaultPost<OM.BackofficeReservationDetailVM>(baseUrl + 'api/Reservation/LoadDocuments', reservation, { }, showSpinner)

  }







































  save(reservation : OM.BackofficeReservationDetailVM, showSpinner = true) : Promise<OM.BackofficeReservationDetailVM> {
    return CommonServices.defaultPost<OM.BackofficeReservationDetailVM>(baseUrl + 'api/Reservation/Save', reservation, { }, showSpinner)

  }







































  payReservationWithUserCredit(reservationIdentifier : string, showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/Reservation/PayReservationWithUserCredit', { reservationIdentifier }, showSpinner)

  }







































  addSeconDriver(secondDriver : OM.SecondDriverVM, showSpinner = true) : Promise<OM.SecondDriver> {
    return CommonServices.defaultPost<OM.SecondDriver>(baseUrl + 'api/Reservation/AddSeconDriver', secondDriver, { }, showSpinner)

  }







































  copyCheckoutDataFromReservation(model : OM.CopyContractFromReservationVm, showSpinner = true) : Promise<void> {
    return CommonServices.defaultPost<void>(baseUrl + 'api/Reservation/CopyCheckoutDataFromReservation', model, { }, showSpinner)

  }







































  getReservationsWithCopyableContractData(reservationIdentifier : string, showSpinner = true) : Promise<OM.CopyContractFromReservationVm[]> {
    return CommonServices.defaultGet<OM.CopyContractFromReservationVm[]>(baseUrl + 'api/Reservation/GetReservationsWithCopyableContractData', { reservationIdentifier }, showSpinner)

  }


















































  setSecondDriverStatus(reservationIdentifier : string, secondDriverStatus : boolean, showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/Reservation/SetSecondDriverStatus', { reservationIdentifier, secondDriverStatus }, showSpinner)

  }







































  resetSecondDriver(reservationIdentifier : string, showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/Reservation/ResetSecondDriver', { reservationIdentifier }, showSpinner)

  }







































  getContractPhoto(reservationIdentifier : string, showSpinner = true) : Promise<OM.ContractPhotoVM> {
    return CommonServices.defaultGet<OM.ContractPhotoVM>(baseUrl + 'api/Reservation/GetContractPhoto', { reservationIdentifier }, showSpinner)

  }
}
export let ReservationClient = new _ReservationClient();

class _StripeClient {







































  managePaymentIntent(stripePaymentVm : OM.StripePaymentRequestVM, showSpinner = true) : Promise<OM.StripeIntentResponseVM> {
    return CommonServices.defaultPost<OM.StripeIntentResponseVM>(baseUrl + 'api/Stripe/ManagePaymentIntent', stripePaymentVm, { }, showSpinner)

  }







































  managePaymentIntentForMobilityCard(stripeCardPaymentVm : OM.StripePaymentMobilityCardVM, showSpinner = true) : Promise<OM.StripeIntentResponseVM> {
    return CommonServices.defaultPost<OM.StripeIntentResponseVM>(baseUrl + 'api/Stripe/ManagePaymentIntentForMobilityCard', stripeCardPaymentVm, { }, showSpinner)

  }






































  capturePaymentIntent(reservationIdentifier : string, showSpinner = true) : Promise<void> {
    return CommonServices.defaultPost<void>(baseUrl + 'api/Stripe/CapturePaymentIntent?reservationIdentifier=' + reservationIdentifier, { }, { }, showSpinner)

  }






































  cancelPaymentIntent(reservationIdentifier : string, showSpinner = true) : Promise<void> {
    return CommonServices.defaultPost<void>(baseUrl + 'api/Stripe/CancelPaymentIntent?reservationIdentifier=' + reservationIdentifier, { }, { }, showSpinner)

  }






































  cancelPaymentIntentForCard(cardIdentifier : string, showSpinner = true) : Promise<void> {
    return CommonServices.defaultPost<void>(baseUrl + 'api/Stripe/CancelPaymentIntentForCard?cardIdentifier=' + cardIdentifier, { }, { }, showSpinner)

  }







































  createCustomer(customerVM : OM.StripeCustomerVM, showSpinner = true) : Promise<string> {
    return CommonServices.defaultPost<string>(baseUrl + 'api/Stripe/CreateCustomer', customerVM, { }, showSpinner)

  }







































  addPaymentMethodToCustomer(addCustomerCardVM : OM.StripeCustomerCardVM, showSpinner = true) : Promise<void> {
    return CommonServices.defaultPost<void>(baseUrl + 'api/Stripe/AddPaymentMethodToCustomer', addCustomerCardVM, { }, showSpinner)

  }




























  listCustomerCards(showSpinner = true) : Promise<OM.StripeCardDetailVM[]> {
    return CommonServices.defaultGet<OM.StripeCardDetailVM[]>(baseUrl + 'api/Stripe/ListCustomerCards', {  }, showSpinner)

  }







































  listCustomerCardsBackoffice(userIdentifier : string, showSpinner = true) : Promise<OM.StripeCardDetailVM[]> {
    return CommonServices.defaultGet<OM.StripeCardDetailVM[]>(baseUrl + 'api/Stripe/ListCustomerCardsBackoffice', { userIdentifier }, showSpinner)

  }




























  setupIntentforCustomerCardSaving(showSpinner = true) : Promise<void> {
    return CommonServices.defaultPost<void>(baseUrl + 'api/Stripe/SetupIntentforCustomerCardSaving', null, { }, showSpinner)

  }







































  detachPaymentMethodFromCustomer(detachCustomerCardVM : OM.StripeCustomerCardVM, showSpinner = true) : Promise<void> {
    return CommonServices.defaultPost<void>(baseUrl + 'api/Stripe/DetachPaymentMethodFromCustomer', detachCustomerCardVM, { }, showSpinner)

  }







































  addCardToCustomer(attachCustomerCardVM : OM.StripeCustomerCardVM, showSpinner = true) : Promise<OM.StripeCardDetailVM> {
    return CommonServices.defaultPost<OM.StripeCardDetailVM>(baseUrl + 'api/Stripe/AddCardToCustomer', attachCustomerCardVM, { }, showSpinner)

  }




























  webhook(showSpinner = true) : Promise<void> {
    return CommonServices.defaultPost<void>(baseUrl + 'api/Stripe/Webhook', null, { }, showSpinner)

  }
}
export let StripeClient = new _StripeClient();

class _TestClient {




























  warning(showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/Test/Warning', {  }, showSpinner)

  }




























  errorGet(showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/Test/Error', {  }, showSpinner)

  }






































  errorPost(data : any, showSpinner = true) : Promise<void> {
    return CommonServices.defaultPost<void>(baseUrl + 'api/Test/Error?data=' + data, { }, { }, showSpinner)

  }




























  getErrorVm(showSpinner = true) : Promise<OM.ErrorVm> {
    return CommonServices.defaultGet<OM.ErrorVm>(baseUrl + 'api/Test/GetErrorVm', {  }, showSpinner)

  }




























  checkLogin(showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/Test/CheckLogin', {  }, showSpinner)

  }







































  generatePdf(generatePdfVM : OM.GeneratePdfVM, showSpinner = true) : Promise<void> {
    return CommonServices.defaultPost<void>(baseUrl + 'api/Test/GeneratePdf', generatePdfVM, { }, showSpinner)

  }
}
export let TestClient = new _TestClient();

class _UploadClient {




























  uploadCartaIdentitaFronte(showSpinner = true) : Promise<OM.LicenseVM> {
    return CommonServices.defaultPost<OM.LicenseVM>(baseUrl + 'api/Upload/UploadCartaIdentitaFronte', null, { }, showSpinner)

  }




























  uploadCartaIdentitaRetro(showSpinner = true) : Promise<OM.LicenseVM> {
    return CommonServices.defaultPost<OM.LicenseVM>(baseUrl + 'api/Upload/UploadCartaIdentitaRetro', null, { }, showSpinner)

  }




























  addVehiclePhoto(showSpinner = true) : Promise<void> {
    return CommonServices.defaultPost<void>(baseUrl + 'api/Upload/AddVehiclePhoto', null, { }, showSpinner)

  }




























  saveCustomer(showSpinner = true) : Promise<string> {
    return CommonServices.defaultPost<string>(baseUrl + 'api/Upload/SaveCustomer', null, { }, showSpinner)

  }
}
export let UploadClient = new _UploadClient();

class _UserClient {







































  login(model : OM.LanguageCredential, showSpinner = true) : Promise<OM.LoggedUserVM> {
    return CommonServices.defaultPost<OM.LoggedUserVM>(baseUrl + 'api/User/Login', model, { }, showSpinner)

  }




























  checkIfProfileIsValid(showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/User/CheckIfProfileIsValid', {  }, showSpinner)

  }




























  getCompleteProfileVM(showSpinner = true) : Promise<OM.CompleteProfileVM> {
    return CommonServices.defaultGet<OM.CompleteProfileVM>(baseUrl + 'api/User/GetCompleteProfileVM', {  }, showSpinner)

  }







































  completeProfile(vm : OM.CompleteProfileVM, showSpinner = true) : Promise<string> {
    return CommonServices.defaultPost<string>(baseUrl + 'api/User/CompleteProfile', vm, { }, showSpinner)

  }







































  sendVerificationPhone(phone : string, showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/User/SendVerificationPhone', { phone }, showSpinner)

  }







































  checkVerificationPhone(code : string, showSpinner = true) : Promise<boolean> {
    return CommonServices.defaultGet<boolean>(baseUrl + 'api/User/CheckVerificationPhone', { code }, showSpinner)

  }







































  setFCMID(fcmIdValue : string, showSpinner = true) : Promise<string> {
    return CommonServices.defaultGet<string>(baseUrl + 'api/User/SetFCMID', { fcmIdValue }, showSpinner)

  }






































  impersonate(userToImpersonateIdentifier : string, showSpinner = true) : Promise<OM.ImpersonatedUserVM> {
    return CommonServices.defaultPost<OM.ImpersonatedUserVM>(baseUrl + 'api/User/Impersonate?userToImpersonateIdentifier=' + userToImpersonateIdentifier, { }, { }, showSpinner)

  }




























  getInternalUsers(showSpinner = true) : Promise<OM.WithLocationUserVM[]> {
    return CommonServices.defaultGet<OM.WithLocationUserVM[]>(baseUrl + 'api/User/GetInternalUsers', {  }, showSpinner)

  }




























  getCustomers(showSpinner = true) : Promise<OM.CustomerVM[]> {
    return CommonServices.defaultGet<OM.CustomerVM[]>(baseUrl + 'api/User/GetCustomers', {  }, showSpinner)

  }







































  getCustomersListForSelect(inputData : string, showSpinner = true) : Promise<OM.CustomerVM[]> {
    return CommonServices.defaultGet<OM.CustomerVM[]>(baseUrl + 'api/User/GetCustomersListForSelect', { inputData }, showSpinner)

  }




























  getSubmittedCustomers(showSpinner = true) : Promise<OM.CustomerVM[]> {
    return CommonServices.defaultGet<OM.CustomerVM[]>(baseUrl + 'api/User/GetSubmittedCustomers', {  }, showSpinner)

  }




























  getRole(showSpinner = true) : Promise<string> {
    return CommonServices.defaultGet<string>(baseUrl + 'api/User/GetRole', {  }, showSpinner)

  }







































  getById(identifier : string, showSpinner = true) : Promise<OM.UserVM> {
    return CommonServices.defaultGet<OM.UserVM>(baseUrl + 'api/User/GetById', { identifier }, showSpinner)

  }




























  getLocationManagers(showSpinner = true) : Promise<OM.ThumbnailBaseUserVM[]> {
    return CommonServices.defaultGet<OM.ThumbnailBaseUserVM[]>(baseUrl + 'api/User/GetLocationManagers', {  }, showSpinner)

  }




























  getProfessionalOwners(showSpinner = true) : Promise<OM.ThumbnailBaseUserVM[]> {
    return CommonServices.defaultGet<OM.ThumbnailBaseUserVM[]>(baseUrl + 'api/User/GetProfessionalOwners', {  }, showSpinner)

  }




























  getApiProfessionalOwners(showSpinner = true) : Promise<OM.ThumbnailBaseUserVM[]> {
    return CommonServices.defaultGet<OM.ThumbnailBaseUserVM[]>(baseUrl + 'api/User/GetApiProfessionalOwners', {  }, showSpinner)

  }




























  getVehicleOwners(showSpinner = true) : Promise<OM.ThumbnailBaseUserVM[]> {
    return CommonServices.defaultGet<OM.ThumbnailBaseUserVM[]>(baseUrl + 'api/User/GetVehicleOwners', {  }, showSpinner)

  }







































  saveInternalUser(user : OM.WithLocationUserVM, showSpinner = true) : Promise<OM.WithLocationUserVM> {
    return CommonServices.defaultPost<OM.WithLocationUserVM>(baseUrl + 'api/User/SaveInternalUser', user, { }, showSpinner)

  }




























  getOwnerList(showSpinner = true) : Promise<OM.CustomerVM[]> {
    return CommonServices.defaultGet<OM.CustomerVM[]>(baseUrl + 'api/User/GetOwnerList', {  }, showSpinner)

  }




























  getPrefissiList(showSpinner = true) : Promise<OM.ExtendedCountry[]> {
    return CommonServices.defaultGet<OM.ExtendedCountry[]>(baseUrl + 'api/User/GetPrefissiList', {  }, showSpinner)

  }







































  changePassword(changePassword : OM.ChangePasswordVM, showSpinner = true) : Promise<void> {
    return CommonServices.defaultPost<void>(baseUrl + 'api/User/ChangePassword', changePassword, { }, showSpinner)

  }







































  approve(model : OM.EntityApproveVm, showSpinner = true) : Promise<void> {
    return CommonServices.defaultPost<void>(baseUrl + 'api/User/Approve', model, { }, showSpinner)

  }







































  refuse(model : OM.EntityApproveVm, showSpinner = true) : Promise<void> {
    return CommonServices.defaultPost<void>(baseUrl + 'api/User/Refuse', model, { }, showSpinner)

  }







































  setPreference(setPreference : OM.SetPreferenceVM, showSpinner = true) : Promise<void> {
    return CommonServices.defaultPost<void>(baseUrl + 'api/User/SetPreference', setPreference, { }, showSpinner)

  }







































  resetPassword(model : OM.LanguageCredential, showSpinner = true) : Promise<void> {
    return CommonServices.defaultPost<void>(baseUrl + 'api/User/ResetPassword', model, { }, showSpinner)

  }




























  getUserSummary(showSpinner = true) : Promise<OM.UserSummaryVM> {
    return CommonServices.defaultGet<OM.UserSummaryVM>(baseUrl + 'api/User/GetUserSummary', {  }, showSpinner)

  }







































  changeStatus(userIdentifier : string, showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/User/ChangeStatus', { userIdentifier }, showSpinner)

  }







































  updatePreferredCulture(culture : string, showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/User/UpdatePreferredCulture', { culture }, showSpinner)

  }
}
export let UserClient = new _UserClient();

class _VehicleConfigurationClient {


















































  addBrand(brandName : string, brandIdentifier : string, showSpinner = true) : Promise<OM.BrandListVM> {
    return CommonServices.defaultGet<OM.BrandListVM>(baseUrl + 'api/VehicleConfiguration/AddBrand', { brandName, brandIdentifier }, showSpinner)

  }




























  getBrandList(showSpinner = true) : Promise<OM.BrandListVM[]> {
    return CommonServices.defaultGet<OM.BrandListVM[]>(baseUrl + 'api/VehicleConfiguration/GetBrandList', {  }, showSpinner)

  }




























  getEnabeldBrandList(showSpinner = true) : Promise<OM.BrandListVM[]> {
    return CommonServices.defaultGet<OM.BrandListVM[]>(baseUrl + 'api/VehicleConfiguration/GetEnabeldBrandList', {  }, showSpinner)

  }







































  saveVehicle(vehicle : OM.ModelListVM, showSpinner = true) : Promise<OM.ModelListVM> {
    return CommonServices.defaultPost<OM.ModelListVM>(baseUrl + 'api/VehicleConfiguration/SaveVehicle', vehicle, { }, showSpinner)

  }




























  getModelList(showSpinner = true) : Promise<OM.ModelListVM[]> {
    return CommonServices.defaultGet<OM.ModelListVM[]>(baseUrl + 'api/VehicleConfiguration/GetModelList', {  }, showSpinner)

  }




























  getEnabledModelList(showSpinner = true) : Promise<OM.ModelListVM[]> {
    return CommonServices.defaultGet<OM.ModelListVM[]>(baseUrl + 'api/VehicleConfiguration/GetEnabledModelList', {  }, showSpinner)

  }







































  getModelByBrandId(brandIdentifier : string, showSpinner = true) : Promise<OM.ModelListVM[]> {
    return CommonServices.defaultGet<OM.ModelListVM[]>(baseUrl + 'api/VehicleConfiguration/GetModelByBrandId', { brandIdentifier }, showSpinner)

  }




























  getModelTextIdentifier(showSpinner = true) : Promise<OM.TextIdentifier[]> {
    return CommonServices.defaultGet<OM.TextIdentifier[]>(baseUrl + 'api/VehicleConfiguration/GetModelTextIdentifier', {  }, showSpinner)

  }







































  changeBrandStatus(brandIdentifier : string, showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/VehicleConfiguration/ChangeBrandStatus', { brandIdentifier }, showSpinner)

  }


















































  changeModelStatus(brandIdentifier : string, modelIdentifier : string, showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/VehicleConfiguration/ChangeModelStatus', { brandIdentifier, modelIdentifier }, showSpinner)

  }
}
export let VehicleConfigurationClient = new _VehicleConfigurationClient();

class _VehicleClient {




























  listByOwner(showSpinner = true) : Promise<OM.VehicleListVM[]> {
    return CommonServices.defaultGet<OM.VehicleListVM[]>(baseUrl + 'api/Vehicle/ListByOwner', {  }, showSpinner)

  }




























  listIdTextByOwner(showSpinner = true) : Promise<OM.TextIdentifier[]> {
    return CommonServices.defaultGet<OM.TextIdentifier[]>(baseUrl + 'api/Vehicle/ListIdTextByOwner', {  }, showSpinner)

  }




























  list(showSpinner = true) : Promise<OM.BaseVehicleListVM[]> {
    return CommonServices.defaultGet<OM.BaseVehicleListVM[]>(baseUrl + 'api/Vehicle/List', {  }, showSpinner)

  }







































  getVehicleDetailForBooking(model : OM.SearchVehicleVm, showSpinner = true) : Promise<OM.VehicleDetailVm> {
    return CommonServices.defaultPost<OM.VehicleDetailVm>(baseUrl + 'api/Vehicle/GetVehicleDetailForBooking', model, { }, showSpinner)

  }







































  getVehicle(vehicleIdentifier : string, showSpinner = true) : Promise<OM.VehicleSaveVM> {
    return CommonServices.defaultGet<OM.VehicleSaveVM>(baseUrl + 'api/Vehicle/GetVehicle', { vehicleIdentifier }, showSpinner)

  }







































  getVehicleDetail(vehicleIdentifier : string, showSpinner = true) : Promise<OM.BaseVehicleDetailVm> {
    return CommonServices.defaultGet<OM.BaseVehicleDetailVm>(baseUrl + 'api/Vehicle/GetVehicleDetail', { vehicleIdentifier }, showSpinner)

  }







































  saveVehicle(item : OM.VehicleSaveVM, showSpinner = true) : Promise<OM.OwnCarSelectedVM> {
    return CommonServices.defaultPost<OM.OwnCarSelectedVM>(baseUrl + 'api/Vehicle/SaveVehicle', item, { }, showSpinner)

  }






























































  manageVehicleImages(vehicleIdentifier : string, imagesToRemove : string[], files : File[], progressFn: (prog) => void = null, showSpinner = true) : Promise<void> {
    return CommonServices.uploadFilesToUrl<void>(baseUrl + 'api/Vehicle/ManageVehicleImages?vehicleIdentifier=' + vehicleIdentifier + '&imagesToRemove=' + imagesToRemove, files, { }, progressFn, showSpinner)

  }







































  listTextIdentifier(ownerIdentifier : string, showSpinner = true) : Promise<OM.TextIdentifier[]> {
    return CommonServices.defaultGet<OM.TextIdentifier[]>(baseUrl + 'api/Vehicle/ListTextIdentifier', { ownerIdentifier }, showSpinner)

  }







































  getImages(vehicleIdentifier : string, showSpinner = true) : Promise<OM.VehicleImageVM[]> {
    return CommonServices.defaultGet<OM.VehicleImageVM[]>(baseUrl + 'api/Vehicle/GetImages', { vehicleIdentifier }, showSpinner)

  }







































  updateImages(updateImagesVM : OM.UpdateImagesVM, showSpinner = true) : Promise<OM.VehicleImageVM[]> {
    return CommonServices.defaultPost<OM.VehicleImageVM[]>(baseUrl + 'api/Vehicle/UpdateImages', updateImagesVM, { }, showSpinner)

  }







































  getVehicleStatus(vehicleIdentifier : string, showSpinner = true) : Promise<OM.VechicleStatusVM> {
    return CommonServices.defaultGet<OM.VechicleStatusVM>(baseUrl + 'api/Vehicle/GetVehicleStatus', { vehicleIdentifier }, showSpinner)

  }







































  changeStatus(identifier : string, showSpinner = true) : Promise<void> {
    return CommonServices.defaultGet<void>(baseUrl + 'api/Vehicle/ChangeStatus', { identifier }, showSpinner)

  }







































  changeReservableStatus(model : OM.ChangeReservableStatusVm, showSpinner = true) : Promise<void> {
    return CommonServices.defaultPost<void>(baseUrl + 'api/Vehicle/ChangeReservableStatus', model, { }, showSpinner)

  }







































  approve(model : OM.EntityApproveVm, showSpinner = true) : Promise<void> {
    return CommonServices.defaultPost<void>(baseUrl + 'api/Vehicle/Approve', model, { }, showSpinner)

  }







































  refuse(model : OM.EntityApproveVm, showSpinner = true) : Promise<void> {
    return CommonServices.defaultPost<void>(baseUrl + 'api/Vehicle/Refuse', model, { }, showSpinner)

  }







































  getFeedbacks(vehicleIdentifier : string, showSpinner = true) : Promise<OM.VehicleFeedbackVM> {
    return CommonServices.defaultGet<OM.VehicleFeedbackVM>(baseUrl + 'api/Vehicle/GetFeedbacks', { vehicleIdentifier }, showSpinner)

  }







































  getOwnVehicleDetail(vehicleIdentifier : string, showSpinner = true) : Promise<OM.VehicleDetailVm> {
    return CommonServices.defaultGet<OM.VehicleDetailVm>(baseUrl + 'api/Vehicle/GetOwnVehicleDetail', { vehicleIdentifier }, showSpinner)

  }







































  listByOwnerIdentifier(ownerIdentifier : string, showSpinner = true) : Promise<OM.VehicleListVM[]> {
    return CommonServices.defaultGet<OM.VehicleListVM[]>(baseUrl + 'api/Vehicle/ListByOwnerIdentifier', { ownerIdentifier }, showSpinner)

  }




























  getBackofficeList(showSpinner = true) : Promise<OM.VehicleListVM[]> {
    return CommonServices.defaultGet<OM.VehicleListVM[]>(baseUrl + 'api/Vehicle/GetBackofficeList', {  }, showSpinner)

  }
}
export let VehicleClient = new _VehicleClient();

class _WithdrawRequestClient {




























  getOwnerList(showSpinner = true) : Promise<OM.WithdrawRequest[]> {
    return CommonServices.defaultGet<OM.WithdrawRequest[]>(baseUrl + 'api/WithdrawRequest/GetOwnerList', {  }, showSpinner)

  }




























  getLocationList(showSpinner = true) : Promise<OM.WithdrawRequest[]> {
    return CommonServices.defaultGet<OM.WithdrawRequest[]>(baseUrl + 'api/WithdrawRequest/GetLocationList', {  }, showSpinner)

  }




























  createRequestWithdraw(showSpinner = true) : Promise<void> {
    return CommonServices.defaultPost<void>(baseUrl + 'api/WithdrawRequest/CreateRequestWithdraw', null, { }, showSpinner)

  }







































  denyWithdrawRequest(model : OM.EntityApproveVm, showSpinner = true) : Promise<void> {
    return CommonServices.defaultPost<void>(baseUrl + 'api/WithdrawRequest/DenyWithdrawRequest', model, { }, showSpinner)

  }







































  approveWithdrawRequest(model : OM.EntityApproveVm, showSpinner = true) : Promise<void> {
    return CommonServices.defaultPost<void>(baseUrl + 'api/WithdrawRequest/ApproveWithdrawRequest', model, { }, showSpinner)

  }
}
export let WithdrawRequestClient = new _WithdrawRequestClient();

interface FileParameter {
    data: any;
    fileName: string;
}

interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

class SwaggerException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new SwaggerException(message, status, response, headers, null);
}

function pushHistoryState(customPagedRequestVM: OM.PagedRequestVM, router: VueRouter) {
    var route = router.currentRoute;
    var query = { ...route.query };

    if (customPagedRequestVM instanceof OM.ReservationPagedRequestVM)
        delete query["showCreated"];

    if (customPagedRequestVM instanceof OM.PriceRulePagedRequestVM)
        delete query["showAllRules"];

    const paramsToDelete = [
        "paging.currentPage", "paging.itemsPerPage",
        "paging.skip", "paging.take",
        "sortBy.propertyName", "sortBy.ascending"
    ];

    paramsToDelete.forEach(param => delete query[param]);

    Object.keys(query)
        .filter((x) => x.startsWith("filter."))
        .forEach((key) => {
            delete query[key];
        });

    if (customPagedRequestVM instanceof OM.ReservationPagedRequestVM)
        query["showCreated"] = (<OM.ReservationPagedRequestVM>customPagedRequestVM).showCreated.toString();

    if (customPagedRequestVM instanceof OM.PriceRulePagedRequestVM)
        query["showAllRules"] = (<OM.PriceRulePagedRequestVM>customPagedRequestVM).showAllRules.toString();

    if (customPagedRequestVM.paging) {
        Object.assign(query, {
            "paging.currentPage": customPagedRequestVM.paging.currentPage.toString(),
            "paging.itemsPerPage": customPagedRequestVM.paging.itemsPerPage.toString(),
            "paging.skip": customPagedRequestVM.paging.skip.toString(),
            "paging.take": customPagedRequestVM.paging.take.toString()
        });
    }

    if (customPagedRequestVM.sortBy) {
        Object.assign(query, {
            "sortBy.propertyName": customPagedRequestVM.sortBy.propertyName,
            "sortBy.ascending": customPagedRequestVM.sortBy.ascending.toString()
        });
    }

    Object.entries(customPagedRequestVM.filter).forEach(([key, values]) => {
        values.forEach((value) => {
            if (value) {
                query[`filter[${key}]`] = value;
            }
        });
    });

    if (router.currentRoute.path == route.path &&
        JSON.stringify(query) == JSON.stringify(route.query))
    {
        return;
    }

    router
        .replace({
            path: route.path,
            query: {
                ...query,
            },
        })
        .catch((err) => {
            console.error(err);
        });
}

function getCustomPagedRequestParamsObject(customPagedRequestVM: OM.PagedRequestVM) {
    var paramsObject: any = {};

    if (customPagedRequestVM instanceof OM.ReservationPagedRequestVM)
        paramsObject.showCreated = (<OM.ReservationPagedRequestVM>customPagedRequestVM).showCreated;

    if (customPagedRequestVM instanceof OM.PriceRulePagedRequestVM)
        paramsObject.showAllRules = (<OM.PriceRulePagedRequestVM>customPagedRequestVM).showAllRules;

    Object.entries(customPagedRequestVM.filter).forEach(([key, values]) => {
        values.forEach((value) => {
            if (value) {
                paramsObject[`filter[${key}]`] = value;
            }
        });
    });

    if (customPagedRequestVM.paging) {
        paramsObject["paging.CurrentPage"] = customPagedRequestVM.paging.currentPage;
        paramsObject["paging.ItemsPerPage"] = customPagedRequestVM.paging.itemsPerPage;
        paramsObject["paging.Skip"] = customPagedRequestVM.paging.skip;
        paramsObject["paging.Take"] = customPagedRequestVM.paging.take;
    }

    if (customPagedRequestVM.sortBy) {
        paramsObject["sortBy.PropertyName"] = customPagedRequestVM.sortBy.propertyName;
        paramsObject["sortBy.Ascending"] = customPagedRequestVM.sortBy.ascending;
    }

    return paramsObject;
}